// Live checklist of the team server's password rules under a new-password field (iOS PasswordRulesChecklist,
// GroundTeam/Views/Sync/ChangePasswordSheet.swift): two columns, a green check per met rule, "Passwords match" when a
// confirm field is shown, and the 72-byte maximum listed only while it's exceeded.

import { clsx } from 'clsx';
import { Circle, CircleCheck } from 'lucide-react';
import { passwordChecklist } from '@/auth/passwordPolicy';

export function PasswordChecklist({ password, confirmation }: { password: string; confirmation?: string }) {
  const items = passwordChecklist(password, confirmation);
  return (
    <ul className="grid grid-cols-2 gap-x-3 gap-y-1.5" aria-label="Password requirements">
      {items.map((item) => (
        <li
          key={item.id}
          className={clsx(
            'flex items-start gap-1.5 text-xs transition-colors',
            item.met ? 'text-slate-800 dark:text-slate-100' : 'text-slate-500 dark:text-slate-400',
          )}
        >
          {item.met ? (
            <CircleCheck className="mt-px h-3.5 w-3.5 shrink-0 text-[var(--gt-green)]" aria-hidden />
          ) : (
            <Circle className="mt-px h-3.5 w-3.5 shrink-0 text-slate-400/70" aria-hidden />
          )}
          <span>
            {item.label}
            <span className="sr-only">{item.met ? ', done' : ', not yet'}</span>
          </span>
        </li>
      ))}
    </ul>
  );
}
